<template>
    <modal id="edit-role-name-modal"
           v-model="showModal"
           :title="$fieldTitle('edit', 'role', true)"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">
        <form ref="form"
              :data-url="`${getSubmitURL}/${role.id}`"
              @submit.prevent="submitData">
            <app-form-group
                v-model="formData.name"
                :label="$t('name')"
                :placeholder="$placeholder('name')"
                :error-message="$errorMessage(errors, 'name')"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../Mixin/Global/ModalMixin";
import {APP_ROLES, TENANT_ROLES} from "../../../Config/apiUrl";

export default {
    name: "EditRoleNameModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        role: {
            required: true
        },
        alias: {}
    },
    data() {
        return {
            formData: {
                name: '',
                type_id: ''
            }
        }
    },
    computed: {
        getSubmitURL() {
            return {
                tenant: TENANT_ROLES,
                app: APP_ROLES,
            }[this.alias];
        }
    },
    methods: {
        submitData() {
            this.loading = true;
            this.save(this.formData);
        },
        afterSuccessFromGetEditData({data}) {
            this.formData.name = data.name;
            this.formData.type_id = data.type_id;
            this.preloader = false;
        },
        afterSuccess({data}) {
            this.toastAndReload(data.message, 'role-table');
            this.$hub.$emit('rolesAffected');
            this.loading = false;
            this.closeModal();
        },
        closeModal() {
            $('#edit-role-name-modal').modal('hide');
        }
    },
    watch: {
        'role': {
            handler: function (role) {
                if (role && role.name) {
                    this.formData.name = role.name;
                    this.formData.type_id = role.type_id;
                }
            },
            immediate: true
        }
    }
}
</script>
